import { isGuideSupported } from "@expert/solve-tools";
import type { GuideSourceDetails } from "@expert/solve-tools/src/guides/types";
import type { usePartner } from "@/sdk";
import { isDeviceActivationIntent, isDeviceActivationQueue, isDeviceActivationSupportNumber } from "./isActivation";

interface OpenActivationGuideProps {
    disableAutomaticOpen: boolean;
    intent?: string;
    isCustomerSession: boolean;
    isDeviceActivationGuideIntentAutoOpenEnabled: boolean;
    isGuideOpen: boolean;
    isLoadingSimplrSession: boolean;
    partner: ReturnType<typeof usePartner>;
    supportNumberCalled?: string;
    queueName?: string;
}
export function shouldOpenActivationGuide({
    disableAutomaticOpen,
    intent,
    isCustomerSession,
    isDeviceActivationGuideIntentAutoOpenEnabled,
    isGuideOpen,
    isLoadingSimplrSession,
    partner,
    supportNumberCalled,
    queueName,
}: Readonly<OpenActivationGuideProps>): {
    shouldOpenGuide: boolean;
    sourceDetails?: GuideSourceDetails;
} {
    if (
        !isGuideSupported("Device Activation") ||
        isGuideOpen ||
        !isCustomerSession ||
        disableAutomaticOpen ||
        isLoadingSimplrSession
    )
        return { shouldOpenGuide: false };

    if (isDeviceActivationIntent(intent) && isDeviceActivationGuideIntentAutoOpenEnabled)
        return { shouldOpenGuide: true, sourceDetails: "intent" };
    if (isDeviceActivationQueue({ partner, queueName })) return { shouldOpenGuide: true, sourceDetails: "queue" };
    if (isDeviceActivationSupportNumber({ partner, supportNumberCalled }))
        return { shouldOpenGuide: true, sourceDetails: "tfn" };

    return { shouldOpenGuide: false };
}
